<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolID" style="font-size:smaller;"
                    [(ngModel)]="SchoolID"
                    (ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
                </select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddTimeScanType()">Add Type</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditTimeScanType()">Edit Type</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onDeleteTimeScanType()">Delete Type</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstTimeScanType"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedTimeScanType"
		dataKey="TimeScanTypeID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--TimeScanTypeDesc-->
				<th>
					<p-columnFilter type="text" field="TimeScanTypeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TimeScanTypeCD-->
				<th>
					<p-columnFilter type="text" field="TimeScanTypeCD" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DefinedByDesc-->
				<th>
					<p-columnFilter field="DefinedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDefinedByDesc
								[ngModel]="value"
								[options]="lstDefinedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AvailableToDesc-->
				<th>
					<p-columnFilter field="AvailableToDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAvailableToDesc
								[ngModel]="value"
								[options]="lstAvailableToDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="TimeScanTypeDesc">Description<p-sortIcon field="TimeScanTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="TimeScanTypeCD">Code<p-sortIcon field="TimeScanTypeCD"></p-sortIcon></th>
				<th pSortableColumn="DefinedByDesc">Defined By<p-sortIcon field="DefinedByDesc"></p-sortIcon></th>
				<th pSortableColumn="AvailableToDesc">Available To<p-sortIcon field="AvailableToDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-TimeScanType>
			<tr [pSelectableRow]="TimeScanType" (dblclick)="onRowDblClick(TimeScanType)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ TimeScanType[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="TimeScanType.DefinedByID <= 2 ? 'Red' : 'Black'">
					{{ TimeScanType.DefinedByDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="TimeScanType.SchoolID == 0 ? 'Red' : 'Black'">
					{{ TimeScanType.AvailableToDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
